

<template>
<template v-if="this.field_manager.uuid !== null">
<template v-if="this.field_manager.type === 'form'">
  <div class="bg-white w-fit h-fit fixed left-0 right-0 m-auto top-0 bottom-0 p-6 rounded-xl" style="z-index:6666666666; min-width: 600px; border: 1px solid #e6e6e6; box-shadow: 0px 5px 3px #00000017;">
    <div class="flex"><h1 class="text-2xl flex-1 font-semibold flex-1">Field Manager</h1><button class="pr-4" @click="this.field_manager.uuid = null;">X</button></div>
    <div class="flex mt-2">
      <button style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Fields</button>
    </div>

    <h1 class="mt-4 text-xl flex-1 font-semibold">Left Side</h1>
    <div class="flex flex-col gap-4 mt-4">
      <div class="flex gap-4">
        <div class="flex flex-col gap-2 w-full">
          <label>Field Name</label>
          <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[0].name" type="text" />
        </div>
        <div class="flex flex-col gap-2  w-full">
          <label>Field type</label>
          <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[0].type" type="text" />
        </div>
      </div>
      <div class="flex gap-4">
        <div class="flex flex-col gap-2 w-full" v-if="this.field_manager.fields[0].type !== 'submit'">
          <label>Placeholder</label>
          <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[0].placeholder" type="text" />
        </div>
        <div class="flex flex-col gap-2 w-full" v-if="this.field_manager.fields[0].type !== 'submit'">
          <label>Show Fieldname</label>
          <div class="flex gap-2 w-full">
            <button style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Yes</button>
            <button class="bg-bay" style="padding: 15px; color: black; border-radius: 10px;">No</button>
          </div>
        </div>
      </div>
    </div>

    <h1 class="mt-4 text-xl flex-1 font-semibold" v-if="this.field_manager.fields[1].name !== null">Right Side</h1>
    <div class="flex flex-col gap-4 mt-4" v-if="this.field_manager.fields[1].name !== null">
      <div class="flex gap-4">
        <div class="flex flex-col gap-2 w-full">
          <label>Field Name</label>
          <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[1].name" type="text" />
        </div>
        <div class="flex flex-col gap-2  w-full">
          <label>Field type</label>
          <input class="bg-bay p-4 rounded-xl  w-full" v-model="this.field_manager.fields[1].type" type="text" />
        </div>
      </div>
      <div class="flex gap-4">
        <div class="flex flex-col gap-2 w-full" v-if="this.field_manager.fields[1].type !== 'submit'">
          <label>Placeholder</label>
          <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[1].placeholder" type="text" />
        </div>
        <div class="flex flex-col gap-2 w-full" v-if="this.field_manager.fields[1].type !== 'submit'">
          <label>Show Fieldname</label>
          <div class="flex gap-2 w-full">
            <button style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Yes</button>
            <button class="bg-bay" style="padding: 15px; color: black; border-radius: 10px;">No</button>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full mt-12 mb-4">
      <button @click="this.saveFormData(this.field_manager.uuid, this.field_manager.index)" class="float-right" style="background:rgb(23, 110, 255);padding:15px;color:white;border-radius:10px;">Update Fields</button>
    </div>

  </div>
</template>  
<template v-else-if="this.field_manager.type === 'repeater'">

    <div class="bg-white w-fit h-fit fixed left-0 right-0 m-auto top-0 bottom-0 p-6 rounded-xl" style="z-index:6666666666; min-width: 600px; border: 1px solid #e6e6e6; box-shadow: 0px 5px 3px #00000017; max-height: 600px; overflow: auto;">
      <div class="flex"><h1 class="text-2xl flex-1 font-semibold flex-1">Repeater Manager</h1><button class="pr-4" @click="this.field_manager.uuid = null;">X</button></div>
      <div class="flex mt-2">
        <button style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Fields</button>
      </div>
      <template v-if="this.field_manager.repeater_type === 'faq'">
        <div class="mt-4">
          <label class="block mb-2">{{  this.field_manager.fields[0].name }}</label>
          <input v-model="this.field_manager.fields[0].text" class="bg-bay p-4 rounded-xl w-full mb-2" type="text">

          <label class="block mb-2">{{ this.field_manager.fields[1].name }}</label>
          <textarea v-model="this.field_manager.fields[1].text" class="bg-bay p-4 rounded-xl w-full resize-none" style="min-height:300px;" type="text"></textarea>
        </div>
      </template>
      <template v-else-if="this.field_manager.repeater_type === 'plan'">
        <div class="mt-4">
          <label class="block mb-2">{{  this.field_manager.fields[0].name }}</label>

          <div class="editor flex gap-3 mb-3 mt-4 bg-bay p-3 rounded-lg pl-4 pr-4" style="width: fit-content;">
                      <button @click="this.field_manager.fields[0].text.chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                      <button @click="setLink(this.field_manager.fields[0].text)"><i class="fa-solid fa-link"></i></button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                      <button @click="this.field_manager.fields[0].text.chain().focus().setParagraph().run()">Paragraph</button>
          </div>

          <div class="bg-bay p-4 rounded-xl w-full mb-2">
            <editor-content :editor="this.field_manager.fields[0].text"  />
          </div>
          <label class="block mb-2 mt-2">{{ this.field_manager.fields[1].name }}</label>
          <input v-model="this.field_manager.fields[1].text" class="bg-bay p-4 rounded-xl w-full mb-2" type="text">

          <label class="block mb-2 mt-2">{{  this.field_manager.fields[2].name }}</label>
          <input v-model="this.field_manager.fields[2].text" class="bg-bay p-4 rounded-xl w-full mb-2" type="text">

          <label class="block mb-2 mt-2">{{ this.field_manager.fields[3].name }}</label>

          <div class="editor flex gap-3 mb-3 mt-4 bg-bay p-3 rounded-lg pl-4 pr-4" style="width: fit-content;">
                      <button @click="this.field_manager.fields[3].text.chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                      <button @click="setLink(this.field_manager.fields[3].text)"><i class="fa-solid fa-link"></i></button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                      <button @click="this.field_manager.fields[3].text.chain().focus().setParagraph().run()">Paragraph</button>
          </div>

          <div class="bg-bay p-4 rounded-xl w-full mb-2">
            <editor-content :editor="this.field_manager.fields[3].text"  />
          </div>

          <label class="block mb-2 mt-2">{{  this.field_manager.fields[4].name }}</label>
          <div class="bg-bay p-4 rounded-xl w-full mb-2">
 
            <div class="flex gap-4 mb-4 justify-between">
            <input ref="newBenefit" class="flex-1 bg-white p-4 rounded-xl w-full" placeholder="Add new benefit.." />
            <button style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;"
                    @click="() => {
                      const newBenefitValue = this.$refs.newBenefit.value;
                      field_manager.fields[4].repeater.unshift(newBenefitValue);
                      this.$refs.newBenefit.value = '';
                    }">
              +
            </button>
          </div>


          <template v-for="(item, index) in field_manager.fields[4].repeater" :key="index">
            <div class="flex gap-4 mb-4 justify-between">
              <p class="flex-1 bg-white p-4 rounded-xl w-full">{{ item }}</p>
              <button @click="field_manager.fields[4].repeater.splice(index, 1)" style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Remove</button>
            </div>
          </template>

 
          </div>

          <label class="block mb-2 mt-2">{{ this.field_manager.fields[5].name }}</label>

          <div class="editor flex gap-3 mb-3 mt-4 bg-bay p-3 rounded-lg pl-4 pr-4" style="width: fit-content;">
                      <button @click="this.field_manager.fields[5].text.chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                      <button @click="setLink(this.field_manager.fields[5].text)"><i class="fa-solid fa-link"></i></button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                      <button @click="this.field_manager.fields[5].text.chain().focus().setParagraph().run()">Paragraph</button>
          </div>

          <div class="bg-bay p-4 rounded-xl w-full mb-2">
            <editor-content :editor="this.field_manager.fields[5].text"  />
          </div>
          
          <label class="block mb-2 mt-2">{{  this.field_manager.fields[6].name }}</label>
          <input v-model="this.field_manager.fields[6].text" class="bg-bay p-4 rounded-xl w-full mb-2" type="text">

          <label class="block mb-2 mt-2">{{ this.field_manager.fields[7].name }}</label>
          <input v-model="this.field_manager.fields[7].text" class="bg-bay p-4 rounded-xl w-full mb-2" type="text">

          <label class="block mb-2 mt-2">{{ this.field_manager.fields[8].name }}</label>
          <input v-model="this.field_manager.fields[8].text" class="bg-bay p-4 rounded-xl w-full mb-2" type="text">
          </div>
      </template>

      <div class="w-full mt-12 mb-4">
        <button @click="this.saveFormData(this.field_manager.uuid, this.field_manager.index)" class="float-right" style="background:rgb(23, 110, 255);padding:15px;color:white;border-radius:10px;">Update Fields</button>
      </div>

    </div>

</template>
<template v-else-if="this.field_manager.type === 'gallery-item'">
  <div class="bg-white w-fit h-fit fixed left-0 right-0 m-auto top-0 bottom-0 p-6 rounded-xl" style="z-index:6666666666; min-width: 600px; border: 1px solid #e6e6e6; box-shadow: 0px 5px 3px #00000017;">
    <div class="flex"><h1 class="text-2xl flex-1 font-semibold flex-1">Gallery Item</h1><button class="pr-4" @click="this.field_manager.uuid = null;">X</button></div>
  
    <div class="flex flex-col gap-2 mt-4">
      <label>{{ this.field_manager.fields[0].name }}</label>
      <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[0].value" type="text" />
    </div>
    <div class="flex flex-col gap-2 mt-4">
      <label>{{ this.field_manager.fields[1].name }}</label>
      <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[1].value" type="text" />
    </div>
    <div class="flex flex-col gap-2 mt-4">
      <label>{{ this.field_manager.fields[2].name }}</label>
      <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[2].value" type="text" />
    </div>

    <div class="flex flex-col gap-2 mt-4">
      <button 
       @click="this.saveFormData(this.field_manager.uuid, this.field_manager.index)"
       class="float-right" style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Save image settings</button>
      <button 
      @click="removeImageFormData(this.field_manager.uuid, this.field_manager.index)"
      class="float-right" style="background: #ff2d2d; padding: 15px; color: white; border-radius: 10px;">Remove image from gallery and website</button>  
    </div>

    

  </div>
</template>
<template v-else-if="this.field_manager.type === 'single-image'">
  <div class="bg-white w-fit h-fit fixed left-0 right-0 m-auto top-0 bottom-0 p-6 rounded-xl" style="z-index:6666666666; min-width: 600px; border: 1px solid #e6e6e6; box-shadow: 0px 5px 3px #00000017;">
    <div class="flex"><h1 class="text-2xl flex-1 font-semibold flex-1">Image Item</h1><button class="pr-4" @click="this.field_manager.uuid = null;">X</button></div>
  
    <div class="flex flex-col gap-2 mt-4">
      <label>{{ this.field_manager.fields[0].name }}</label>
      <input class="bg-bay p-4 rounded-xl w-full" v-model="this.field_manager.fields[0].value" type="text" />
    </div>

    <div class="flex flex-col gap-2 mt-4">
      <button 
       @click="this.saveFormData(this.field_manager.uuid, this.field_manager.index)"
       class="float-right" style="background: rgb(23, 110, 255); padding: 15px; color: white; border-radius: 10px;">Save image settings</button>
      <button 
      @click="removeImageFormData(this.field_manager.uuid, this.field_manager.index)"
      class="float-right" style="background: #ff2d2d; padding: 15px; color: white; border-radius: 10px;">Remove image from gallery and website</button>  
    </div>
  </div>
</template>
</template>

<div class="m-8">
    <div class="flex">
    <h1 class="text-2xl flex-1 font-semibold">Page - {{ this.page.name }}</h1>
    </div>

<div class="flex gap-4">
    <div class="bg-bay p-4 mt-4 rounded-xl" style="width:60%;">

      <template v-for="component in this.page_component_list">
        
        <div v-if="JSON.parse(component.data).type === 'text'" class="mb-4 w-full">
        
          <h2  class="text-lg font-semibold">{{ JSON.parse(component.data).title }} Field</h2>

          <div class="editor flex gap-3 mb-3 mt-4 bg-white p-3 rounded-lg pl-4 pr-4" style="width: fit-content;">
                      <button @click="this.editors[component.uuid].chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                      <button @click="setLink(this.editors[component.uuid])"><i class="fa-solid fa-link"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                      <button @click="this.editors[component.uuid].chain().focus().setParagraph().run()">Paragraph</button>

                      <button @click="addImage"><i class="fa-solid fa-image"></i></button>
          </div>
          
          
          <div class="bg-white p-4 rounded-xl">
              <div v-if="this.editors[component.uuid]">
                  <bubble-menu
                      class="bubble-menu"
                      :tippy-options="{ duration: 100 }"
                      :editor="this.editors[component.uuid]"
                  >
                      <button @click="this.editors[component.uuid].chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                      <button @click="setLink(this.editors[component.uuid])"><i class="fa-solid fa-link"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                      <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                      <button @click="this.editors[component.uuid].chain().focus().setParagraph().run()">Paragraph</button>
                  </bubble-menu>

                </div>  

  
              <editor-content :editor="this.editors[component.uuid]"  />

          </div>

        </div>

        <div v-else-if="JSON.parse(component.data).type === 'gallery'" class="mb-4 w-full">
        
        <h2  class="text-lg font-semibold">{{ JSON.parse(component.data).title }} Field</h2>

        <div class="grid grid-cols-3 gap-4">
          
            <div class="bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" :style="{'min-height':'250px','background-image': JSON.parse(component.data).image && JSON.parse(component.data).image.src ? 'url('+cdnUrl(JSON.parse(component.data).image.src)+')' : 'none', 'background-size': 'cover', 'background-position': 'center', 'height': '200px' }">
              <label :for="'gallery_image_'+component.uuid" class="flex flex-col justify-center text-center gap-2">
                <i class="fa-regular fa-image" style="font-size: 3rem;"></i>
                <p class="text-sm">Click to upload an image.</p>
              </label>
              <input 
                :id="'gallery_image_'+component.uuid" 
                type="file" 
                accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" 
                class="upload hidden" 
                name="upload"
                @change="uploadGalleryImage($event, component.uuid)"
              >
            </div>

              <div 
                v-for="(image, index) in JSON.parse(component.data).content.images" 
                :key="index"
                :uuid="image.uuid" 
                class="relative bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" 
                :style="{'background-image': 'url('+cdnUrl(image.src)+')', 'background-size': 'cover', 'background-position': 'center', 'height': '250px' }"
                draggable="true"


                @click="openFormData('gallery-item', component.uuid, image, index)"

                @dragstart="startDrag($event, component.uuid, index)"
                @dragend="endDrag"
                @drag="drag"
                @dragover="dragOver"
                @drop="drop($event, component.uuid, index)"
              >
                  <button class="absolute top-2 right-2 opacity-70 transition-opacity duration-200 text-sm bg-white p-2 rounded-xl" 
                  style="
                  width: fit-content;
                  padding: 1rem;
                  position: absolute;
                  top: calc(200px - 0.5rem);
                    right: 0.5rem;
                    opacity: 1;
                    height: 3rem;
                    padding-top: 0.75rem;
                    background: white;

                  ">
                    <i class="fa-solid fa-grip-vertical text-black cursor-move" style="font-size: 1.5rem;" ></i>
                  </button>
                  <label :for="image.uuid" class="cursor-pointer flex flex-col justify-center text-center gap-2 w-full h-full">
                    <p class="text-sm bg-white p-2 rounded-xl" style="
                    width: fit-content;
                    padding: 1rem;
                    position: absolute;
                    top: 0.5rem;
                    right: 0.5rem;
                    ">
                      <i class="fa-solid fa-pencil"></i>
                    </p>
                  </label>
                </div>
      
        </div>

        </div>

        <div v-else-if="JSON.parse(component.data).type === 'about'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">About</h1>
          <div class="flex gap-8 mt-2">
            <div style="width:50%;">

              <h2 class="block mb-2">About Image</h2>
                <div class="relative bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" :style="{'min-height':'250px','background-image': JSON.parse(component.data).image.src ? 'url('+cdnUrl(JSON.parse(component.data).image.src)+')' : 'none', 'background-size': 'cover', 'background-position': 'center', 'height': '200px' }">
                  <label :for="component.uuid" class="flex flex-col justify-center text-center gap-2"  style="background: white; padding: 1rem; height: 8rem; border-radius: 1.5rem; cursor:pointer;">
                    <i class="fa-regular fa-image" style="font-size: 3rem;"></i>
                    <p v-if="JSON.parse(component.data).image.src === ''" class="text-sm">Click to upload an image.</p>
                    <p v-else class="text-sm">Replace current image.</p>
                  </label>
                 <p @click="openFormData('single-image', component.uuid, JSON.parse(component.data).image, index)" class="text-sm bg-white p-2 rounded-xl cursor-pointer" style="width: fit-content; padding: 1rem; position: absolute; top: 0.5rem; right: 0.5rem;"><i class="fa-solid fa-pencil"></i></p>
                  <input :id="component.uuid" type="file" accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" class="upload hidden" name="upload"  @change="uploadImage($event, component.uuid)">
                </div>

            </div>
            <div style="width:50%;">
  
                <h2 class="block mb-2">About text</h2>
                <div class="bg-white p-4 rounded-xl">
                    <div v-if="this.editors[component.uuid]">
                        <bubble-menu
                            class="bubble-menu"
                            :tippy-options="{ duration: 100 }"
                            :editor="this.editors[component.uuid]"
                        >
                            <button @click="this.editors[component.uuid].chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                            <button @click="setLink(this.editors[component.uuid])"><i class="fa-solid fa-link"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                            <button @click="this.editors[component.uuid].chain().focus().setParagraph().run()">Paragraph</button>
                        </bubble-menu>

                      </div>  

                    <editor-content :editor="this.editors[component.uuid]"  />
                </div>

                <h1 class="text-lg font-semibold mt-4">Socials</h1>
                <div class="w-full flex flex-col gap-2 mt-1">
                  <div class="flex flex-col gap-2">
                    <h3>Insta</h3>
                    <input @input="this.inputUpdate(component.uuid,'insta', $event, 'socials')" :value="JSON.parse(component.data).socials.insta" placeholder="https://www.instagram.com/sesayars/" class="bg-white p-4 rounded-xl" />
                  </div>
                  <div class="flex flex-col gap-2">
                    <h3>Facebook</h3>
                    <input @input="this.inputUpdate(component.uuid,'facebook', $event, 'socials')" :value="JSON.parse(component.data).socials.facebook" placeholder="https://www.facebook.com/.." class="bg-white p-4 rounded-xl" />
                  </div>
                  <div class="flex flex-col gap-2">
                    <h3>Linkedin</h3>
                    <input @input="this.inputUpdate(component.uuid,'linkedin', $event, 'socials')" :value="JSON.parse(component.data).socials.linkedin" placeholder="https://nl.linkedin.com/in/sesayar-scharrenberg-284636240" class="bg-white p-4 rounded-xl" />
                  </div>
                </div>

            </div>
          </div>
        </div>

        <div v-else-if="JSON.parse(component.data).type === 'header'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">Header</h1>
          <div class="flex gap-8 mt-2">
            <div style="width:50%;">

              <h2 class="block mb-2">Header Image</h2>
                <div class="relative bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" :style="{'min-height':'250px','background-image': 'url('+cdnUrl(JSON.parse(component.data).image.src)+')', 'background-size': 'cover', 'background-position': 'center', 'height': '200px' }">
                  <label :for="component.uuid" class="flex flex-col justify-center text-center gap-2"  style="background: white; padding: 1rem; height: 8rem; border-radius: 1.5rem; cursor:pointer;">
                    <i class="fa-regular fa-image" style="font-size: 3rem;"></i>
                    <p v-if="JSON.parse(component.data).image.src === ''" class="text-sm">Click to upload an image.</p>
                    <p v-else class="text-sm">Replace current image.</p>
                  </label>
                 <p @click="openFormData('single-image', component.uuid, JSON.parse(component.data).image, index)" class="text-sm bg-white p-2 rounded-xl cursor-pointer" style="width: fit-content; padding: 1rem; position: absolute; top: 0.5rem; right: 0.5rem;"><i class="fa-solid fa-pencil"></i></p>
                  <input :id="component.uuid" type="file" accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" class="upload hidden" name="upload" @change="uploadImage($event, component.uuid)">
                </div>

            </div>
            <div style="width:50%;">
  
                <h2 class="block mb-2">Header text</h2>
                <div class="bg-white p-4 rounded-xl">
                    <div v-if="this.editors[component.uuid]">
                        <bubble-menu
                            class="bubble-menu"
                            :tippy-options="{ duration: 100 }"
                            :editor="this.editors[component.uuid]"
                        >
                            <button @click="this.editors[component.uuid].chain().focus().toggleBold().run()"><i class="fa-solid fa-bold"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleItalic().run()"><i class="fa-solid fa-italic"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleUnderline().run()"><i class="fa-solid fa-underline"></i></button>
                            <button @click="setLink(this.editors[component.uuid])"><i class="fa-solid fa-link"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().setTextAlign('left').run()"><i class="fa-solid fa-align-left"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().setTextAlign('center').run()"><i class="fa-solid fa-align-center"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().setTextAlign('right').run()"><i class="fa-solid fa-align-right"></i></button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 1 }).run()">H1</button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 2 }).run()">H2</button>
                            <button @click="this.editors[component.uuid].chain().focus().toggleHeading({ level: 3 }).run()">H3</button>
                            <button @click="this.editors[component.uuid].chain().focus().setParagraph().run()">Paragraph</button>
                        </bubble-menu>

                      </div>  

                    <editor-content :editor="this.editors[component.uuid]"  />
                </div>

            </div>
          </div>
        </div>

        <div v-else-if="JSON.parse(component.data).type === 'contact'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">Contact</h1>
          
          <div class="flex gap-8 mt-2">
            <div style="width:50%;">

              <h2 class="block mb-2">Contact Image</h2>
                <div class="relative bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" :style="{'min-height':'250px','background-image': JSON.parse(component.data).image.src ? 'url('+cdnUrl(JSON.parse(component.data).image.src)+')' : 'none', 'background-size': 'cover', 'background-position': 'center', 'height': '200px' }">
                  <label :for="component.uuid" class="flex flex-col justify-center text-center gap-2"  style="background: white; padding: 1rem; height: 8rem; border-radius: 1.5rem; cursor:pointer;">
                    <i class="fa-regular fa-image" style="font-size: 3rem;"></i>
                    <p v-if="JSON.parse(component.data).image.src === ''" class="text-sm">Click to upload an image.</p>
                    <p v-else class="text-sm">Replace current image.</p>
                  </label>
                 <p @click="openFormData('single-image', component.uuid, JSON.parse(component.data).image, index)" class="text-sm bg-white p-2 rounded-xl cursor-pointer" style="width: fit-content; padding: 1rem; position: absolute; top: 0.5rem; right: 0.5rem;"><i class="fa-solid fa-pencil"></i></p>
                  <input :id="component.uuid" type="file" accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" class="upload hidden" name="upload" @change="uploadImage($event, component.uuid)">
                </div>

            </div>
            <div style="width:50%;">
  
                <h2 class="block mb-2">Contact Form</h2>

                <template v-for="(first_gen_field, index) in JSON.parse(component.data).form" :key="index">
                    <template v-if="first_gen_field.type === '1-2-cols'"><div class="flex gap-4 mb-4"> 
                      
                        <div class="bg-white p-4 rounded-xl flex gap-4">
                          <button @click="removeFormData('contact_fields',component.uuid, index)"><i class="fa-solid fa-trash"></i></button>
                            <input :type="first_gen_field.cols[0].type" disabled class="w-full" :placeholder="first_gen_field.cols[0].name" />
                        </div>
                        <div class="bg-white p-4 rounded-xl flex gap-4">
                            <input :type="first_gen_field.cols[1].type" disabled class="w-full" :placeholder="first_gen_field.cols[1].name" />
                            <button @click="openFormData('contact_fields', component.uuid, first_gen_field, index)"><i class="fa-solid fa-pen"></i></button>
                        </div>
                      
                    </div></template>
                    <template v-else>
                        
                      <div v-if="first_gen_field.type === 'text'" class="bg-white p-4 rounded-xl flex gap-4 mb-4">
                        <button @click="removeFormData('contact_fields',component.uuid, index)"><i class="fa-solid fa-trash"></i></button>
                        <input @click="openFormData('contact_fields', component.uuid, first_gen_field, index)" type="email" disabled class="w-full" :placeholder="first_gen_field.name" />
                        <button @click="openFormData('contact_fields', component.uuid, first_gen_field, index)"><i class="fa-solid fa-pen"></i></button>
                      </div>
                      <div v-else-if="first_gen_field.type === 'email'" class="bg-white p-4 rounded-xl flex gap-4 mb-4">
                        <button @click="removeFormData('contact_fields',component.uuid, index)"><i class="fa-solid fa-trash"></i></button>
                        <input @click="openFormData('contact_fields', component.uuid, first_gen_field, index)" type="email" disabled class="w-full" :placeholder="first_gen_field.name" />
                        <button @click="openFormData('contact_fields', component.uuid, first_gen_field, index)"><i class="fa-solid fa-pen"></i></button>
                      </div>
                      <div v-else-if="first_gen_field.type === 'textarea'" class="bg-white p-4 rounded-xl flex gap-4 mb-4">
                        <button @click="removeFormData('contact_fields',component.uuid, index)"><i class="fa-solid fa-trash"></i></button>
                        <textarea @click="openFormData('contact_fields', component.uuid, first_gen_field, index)" disabled class="w-full resize-none h-32" :placeholder="first_gen_field.name"></textarea>
                        <button @click="openFormData('contact_fields', component.uuid, first_gen_field, index)"><i class="fa-solid fa-pen"></i></button>
                      </div>
                      <div v-else-if="first_gen_field.type === 'submit'" class="bg-main p-4 rounded-xl flex gap-4 mb-4">
                        <button @click="removeFormData('contact_fields',component.uuid, index)"><i class="fa-solid fa-trash text-white"></i></button>
                        <button @click="openFormData('contact_fields', component.uuid, first_gen_field, index)" class="text-white w-full flex gap-4"><span class="flex-1">{{first_gen_field.name}}</span></button>
                        <button @click="openFormData('contact_fields', component.uuid, first_gen_field, index)"><i class="fa-solid fa-pen text-white"></i></button>
                      </div>

                    </template>
                </template>



                <div class="flex gap-4 w-full">
                      <div class="bg-main w-1/2 text-center p-4 rounded-xl flex gap-4">
                        <button @click="this.createFormData('form', component.uuid, 'two-field')" class="text-white w-full flex gap-4"><span class="flex-1">Full Field</span><i class="fa-solid fa-plus"></i></button>
                      </div>
                      <div class="bg-main w-1/2 text-center p-4 rounded-xl flex gap-4">
                        <button @click="this.createFormData('form', component.uuid, 'one-field')" class="text-white w-full flex gap-4"><span class="flex-1">Two Fields</span><i class="fa-solid fa-plus"></i></button>
                      </div>
                  </div>



                <h1 class="text-lg font-semibold mt-4">Contact Information</h1>
                <div class="w-full flex flex-col gap-2 mt-1">
                  <div class="flex flex-col gap-2">
                    <h3>Email</h3>
                    <input @input="this.inputUpdate(component.uuid,'email', $event, 'contact_options')" :value="JSON.parse(component.data).contact_options.email" placeholder="sesayar@atw.global" class="bg-white p-4 rounded-xl" />
                  </div>
                  <div class="flex flex-col gap-2">
                    <h3>Telefoon Nummer</h3>
                    <input @input="this.inputUpdate(component.uuid,'tel', $event, 'contact_options')" :value="JSON.parse(component.data).contact_options.tel" placeholder="+31 0613448820" class="bg-white p-4 rounded-xl" />
                  </div>
                </div>

            </div>
          </div>
        </div>

        <div v-else-if="JSON.parse(component.data).type === 'contact_box_horizontal'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">Contact Information</h1>
          
          <div class="flex gap-8 mt-2">
            <div class="w-full">
                <div class="w-full flex flex-col gap-2 mt-1">
                  <div class="flex flex-col gap-2">
                    <h3>Email</h3>
                    <input @input="this.inputUpdate(component.uuid,'email', $event, 'fields')" :value="JSON.parse(component.data).fields.email" placeholder="sesayar@atw.global" class="bg-white p-4 rounded-xl" />
                  </div>
                  <div class="flex flex-col gap-2 mt-2">
                    <h3>Telefoon Nummer</h3>
                    <input @input="this.inputUpdate(component.uuid,'phone', $event, 'fields')" :value="JSON.parse(component.data).fields.phone" placeholder="+31 0613448820" class="bg-white p-4 rounded-xl" />
                  </div>
                </div>

            </div>
          </div>
        </div>

        <div v-else-if="JSON.parse(component.data).type === 'faq-image'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">FAQ + Image</h1>
          <div class="flex gap-8 mt-2">

            <div style="width:50%;">
  
              <h2 class="block mb-2">FAQ List</h2>
              <div class="flex flex-col gap-4">

                <template v-for="(faq, index) in JSON.parse(component.data).faq.repeater" :key="index">
                  <div class="flex bg-white p-4 rounded-xl gap-4">
                    <button @click="removeFormData('faq',component.uuid, index)"><i class="fa-solid fa-trash"></i></button>
                    <p class="flex-1">{{ faq.q }}</p>
                    <button @click="openFormData('faq', component.uuid, faq, index)"><i class="fa-solid fa-pen"></i></button>
                  </div>
                </template>
                <div class="bg-main w-full text-center p-4 rounded-xl flex gap-4"><button @click="this.createFormData('faq', component.uuid, 'question')" class="text-white w-full flex gap-4"><span class="flex-1">New Question</span><i class="fa-solid fa-plus"></i></button></div>

              </div>
          </div>
            <div style="width:50%;">

              <h2 class="block mb-2">FAQ Image</h2>
                <div class="relative bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" :style="{'min-height':'250px','background-image': JSON.parse(component.data).image.src ? 'url('+cdnUrl(JSON.parse(component.data).image.src)+')' : 'none', 'background-size': 'cover', 'background-position': 'center', 'height': '200px' }">
                  <label :for="component.uuid" class="flex flex-col justify-center text-center gap-2"  style="background: white; padding: 1rem; height: 8rem; border-radius: 1.5rem; cursor:pointer;">
                    <i class="fa-regular fa-image" style="font-size: 3rem;"></i>
                    <p v-if="JSON.parse(component.data).image.src === ''" class="text-sm">Click to upload an image.</p>
                    <p v-else class="text-sm">Replace current image.</p>
                  </label>
                 <p @click="openFormData('single-image', component.uuid, JSON.parse(component.data).image, index)" class="text-sm bg-white p-2 rounded-xl cursor-pointer" style="width: fit-content; padding: 1rem; position: absolute; top: 0.5rem; right: 0.5rem;"><i class="fa-solid fa-pencil"></i></p>
                  <input :id="component.uuid" type="file" accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" class="upload hidden" name="upload" @change="uploadImage($event, component.uuid)">
                </div>

            </div>

          </div>

        </div>

        <div v-else-if="JSON.parse(component.data).type === 'pricing_plans'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">Pricing Plans</h1>
          <div class="flex gap-8 mt-2">

            <div style="width:100%;">
  
              <h2 class="block mb-2">Plans</h2>
              <div class="flex flex-col gap-4">

                <template v-for="(plan, index) in JSON.parse(component.data).plans.repeater" :key="index">
                  <div class="flex bg-white p-4 rounded-xl gap-4">
                    <button @click="removeFormData('plans',component.uuid, index)"><i class="fa-solid fa-trash"></i></button>
                    <p class="flex-1">{{ EditorObjectToHTML(plan.title) }}</p>
                    <button @click="openFormData('plans', component.uuid, plan, index)"><i class="fa-solid fa-pen"></i></button>
                  </div>
                </template>
                <div class="bg-main w-full text-center p-4 rounded-xl flex gap-4"><button @click="this.createFormData('plans', component.uuid, 'plan')" class="text-white w-full flex gap-4"><span class="flex-1">New Plan</span><i class="fa-solid fa-plus"></i></button></div>

              </div>
          </div>


          </div>

        </div>

        <div v-else-if="JSON.parse(component.data).type === 'cv'" class="mb-4 w-full">
          <h1  class="text-lg font-semibold">CV Table's</h1>

          <componentTable :uuid="component.uuid" :content="JSON.parse(component.data).content" @contentUpdated="handleData" />

        </div>

        <div v-else-if="JSON.parse(component.data).type === 'insta-carrousel'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">Insta Carrousel</h1>
          <input :value="JSON.parse(component.data).profile" @input="this.inputUpdate(component.uuid,'profile', $event)" placeholder="https://www.instagram.com/sesayars/" class="w-full mt-1 bg-white p-4 rounded-xl" />
        </div>

        <div v-else-if="JSON.parse(component.data).type === 'double-text'" class="mb-4 w-full">
          <h1 class="text-lg font-semibold">Double Text</h1>
          <div class="flex gap-8 mt-2" v-if="this.editors[component.uuid]">
            <div class="w-1/2" v-if="this.editors[component.uuid]['col_1']">
              <h2 class="block mb-2">Left Text</h2>
              <div class="bg-white p-4 rounded-xl">
                  <editor-content :editor="this.editors[component.uuid]['col_1']" />
              </div>
            </div>
            <div class="w-1/2" v-if="this.editors[component.uuid]['col_2']">
              <h2 class="block mb-2">Right Text</h2>
              <div class="bg-white p-4 rounded-xl">
                  <editor-content :editor="this.editors[component.uuid]['col_2']" />
              </div>
            </div>
          </div>
        </div>

        <hr style="border-top: 1px solid #b9bfc7; margin-top: 2.5rem; margin-bottom: 1.5rem;">
      </template>

    </div>
    <div class="bg-bay p-4 mt-4 rounded-xl" style="width:40%;">

        <h2 class="mb-2 text-md">Page Title</h2>
        <input v-model="this.page.name" class="bg-white p-4 rounded-xl w-full mb-1 mt-1"  :maxlength="80"  />
        <label class="text-sm mb-3 text-right block">{{ this.page.name.length }}/80</label>

        <h2 class="mb-2 text-md" style="margin-top: -0.5rem;">Page Description</h2>

        <input v-model="generalDescription" class="bg-white p-4 rounded-xl w-full mb-1 mt-1"  :maxlength="120" />
        <label class="text-sm text-right mb-3 block">{{ generalDescription.length }}/120</label>

        <div class="flex gap-4" style="margin-top: -0.5rem;">
            <div style="width:50%;">
                <h2 class="mb-2 text-md">Page Type</h2>
                <div class="relative mb-3 on-hover">
                    <input disabled :value="getGeneral('key', 'type').value" class="bg-white p-4 rounded-xl w-full mt-1" style="z-index: 100000; position: relative; " />
                    <div class="hover-on flex flex-col  bg-white p-4 rounded-xl w-full mt-1" style=" position: absolute; top: 2rem;  outline: 1px solid #c6c6c6; padding-top: 2.1rem; gap: 0.8rem;">
                        <p @click="ChangeType('Normal')" v-if="getGeneral('key', 'type').value !== 'Normal'">Normal</p>
                        <p @click="ChangeType('Portfolio')" v-if="getGeneral('key', 'type').value !== 'Portfolio'">Portfolio</p>
                    </div>   
                </div>
            </div><div style="width:50%;">

                <h2 class="mb-2 text-md">Page Visibility</h2>
                <div class="relative mb-3 on-hover">
                    <input disabled :value="this.getGeneral('key', 'visibility').value" class="bg-white p-4 rounded-xl w-full mt-1" style="z-index: 100000; position: relative; " />
                    <div class="hover-on flex flex-col  bg-white p-4 rounded-xl w-full mt-1" style=" position: absolute; top: 2rem;  outline: 1px solid #c6c6c6; padding-top: 2.1rem; gap: 0.8rem;">
                        <p @click="ChangeVis('Public')" v-if="getGeneral('key', 'visibility').value !== 'Public'">Public</p>
                        <p @click="ChangeVis('Private')" v-if="getGeneral('key', 'visibility').value !== 'Private'">Private</p>
                    </div>   
                </div>
                
            </div>
        </div>
        
        <h2 class="mb-2 text-md mt-3">Page Date</h2>
        <input type="date" v-model="generalDate" class="bg-white p-4 rounded-xl w-full mb-3 mt-1" />
        <h2 class="mb-2 text-md mt-3">Thumbnail</h2>
        <div class="bg-white p-4 rounded-xl w-full mb-3 mt-1 flex justify-center items-center" style="min-height: 200px;">

            <p v-if="uploading">Uploading...</p>

            <label for="uploadBtn" v-else-if="fileUrl !== null && uploadSuccess">
                <img :src="fileUrl" />
            </label>
            
            <label for="uploadBtn" v-else-if="uploadError" class="flex flex-col justify-center text-center gap-2">
                <i @click="showFileUpload" class="fa-regular fa-image" style="font-size: 3rem;"></i>
                <p class="text-sm">Upload Failed! ({{ uploadFailedReason }})</p>
            </label>
            
            <label for="uploadBtn" v-else-if="fileUrl !== null">
                <img :src="fileUrl" />
            </label>

            <label v-else for="uploadBtn" class="flex flex-col justify-center text-center gap-2">
            <i @click="showFileUpload" class="fa-regular fa-image" style="font-size: 3rem;"></i>
            <p class="text-sm">Click to upload an image.</p>
            </label>
            <input @change="handleFileUpload" id="uploadBtn" type="file" accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" class="upload hidden" name="upload" />
        </div>



    </div>
</div>



<button v-if="this.saveBTN === 'Failed to save'" style="background:red; position: fixed; bottom: 20px; right: 40px; padding: 15px; color: white; border-radius: 10px;" @click="save">{{ this.saveBTN }}</button>
<button v-else style="position: fixed; bottom: 20px; right: 40px; background: #176eff; padding: 15px; color: white; border-radius: 10px;" @click="save">{{ this.saveBTN }}</button>
</div>




 </template>
  
<script>
import StarterKit from '@tiptap/starter-kit'
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Heading from '@tiptap/extension-heading';
import Paragraph from '@tiptap/extension-paragraph';
import Image from '@tiptap/extension-image'
import Document from '@tiptap/extension-document'
import Dropcursor from '@tiptap/extension-dropcursor'



import axios from 'axios'
import Layout from '@/Shared/layout/editor'

import componentTable from '@/Shared/cms/components/table/field'

  import {
    BubbleMenu,
    Editor,
    EditorContent,
    FloatingMenu,
  } from '@tiptap/vue-3'
  

  export default {
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,

  props: {
    page_components: Array,
    pages: Array,
    page_general: Array,
    site_uuid: String,
    page_uuid: String,
    page: Object,
    domain: String,
  },

    components: {
      EditorContent,
      BubbleMenu,
      FloatingMenu,
      componentTable
    },
  
    data() {
      return {
        page_component_list: this.page_components,
        page_data: this.pages,
        general: this.page_general,
        editor: null,
        editors: {},
        type: 'Normal',
        visibility: 'Public',
        title: '',
        description: '',
        saveBTN: 'Save Now',
            selectedFile: null,
            uploading: false,
            uploadSuccess: false,
            uploadError: false,
            uploadLink: "https://edwindeklein.nl/dvledwin/v1/connect/select/files/upload-new.php",
            uploadKey: "66b90fcd7c72d",
            fileUrl: null,
            uploadFailedReason: "",
            cdn_domain: "files.atw.global",
        field_manager: {uuid: null, index: null, fields: [
          {
            "name": null,
            "type": "",
            "placeholder": "",
            "show_name": true
          },
          {
            "name": null,
            "type": "",
            "placeholder": "",
            "show_name": true
          }
        ]},

        draggedZone: null,
        dropZone: null    
        
      }
    },

    mounted() {

      //this.editors = {}; // Initialize as an object

      this.page_components.forEach(item => {

        // filter out those that don't use the editor.
        if(JSON.parse(item.data).type !== 'contact' && JSON.parse(item.data).type !==  'insta-carrousel'){

          // Store the editor instance using the uuid as a key
          if(JSON.parse(item.data).type === 'double-text'){

            const editorField = new Editor({
            extensions: [
              StarterKit,
              Bold,
              Italic,
              Underline,
              Link.configure({ openOnClick: false }),
              TextAlign.configure({ types: ['heading', 'paragraph'] }),
              Heading.configure({ levels: [1, 2, 3] }),
              Paragraph,
              Image,
              Dropcursor,
              Document,
            ],
            content: JSON.parse(item.data).col_1,
          });
          const editorField_2 = new Editor({
            extensions: [
              StarterKit,
              Bold,
              Italic,
              Underline,
              Link.configure({ openOnClick: false }),
              TextAlign.configure({ types: ['heading', 'paragraph'] }),
              Heading.configure({ levels: [1, 2, 3] }),
              Paragraph,
              Image,
              Dropcursor,
              Document,
            ],
            content: JSON.parse(item.data).col_2,
          });
            this.editors[item.uuid] = [];

            this.editors[item.uuid]['col_1'] = editorField;
            this.editors[item.uuid]['col_2'] = editorField_2;
            
          } else {

            const editorField = new Editor({
            extensions: [
              StarterKit,
              Bold,
              Italic,
              Underline,
              Link.configure({ openOnClick: false }),
              TextAlign.configure({ types: ['heading', 'paragraph'] }),
              Heading.configure({ levels: [1, 2, 3] }),
              Paragraph,
              Image,
              Dropcursor,
              Document,
            ],
            content: JSON.parse(item.data).content,
          });

            this.editors[item.uuid] = editorField;
          }
        }

          // console.log("DEBUG:")
          // console.log(this.editors)
          
      });

      // Access the editor using uuid
      //const editor = this.editors["thisismyuuid"];



      // this.editor = new Editor({
      //   extensions: [
      //   StarterKit,
      //   Bold,
      //   Italic,
      //   Underline,
      //   Link.configure({ openOnClick: false }),
      //   TextAlign.configure({ types: ['heading', 'paragraph'] }),
      //   Heading.configure({ levels: [1, 2, 3] }),
      //   Paragraph,
      //   Image,
      //   Dropcursor,
      //   Document,
      //   ],
      //   content: `
      //     <p>
      //       Try to select <em>this text</em> to see what we call the bubble menu.
      //     </p>
      //     <p>
      //       Neat, isn’t it? Add an empty paragraph to see the floating menu.
      //     </p>
      //   `,
      // })

      const currentUrl = window.location.href;
        const captureUrl = currentUrl.replace('/site', '/site/capture');
        const MAX_RETRIES = 3; // Maximum number of retries

        let retryCount = 0; // Keeps track of retries

        // const captureScreenshot = async () => {
        // console.log("Trying to request a screenshot...");

        // try {
        //     const response = await axios.get(captureUrl);
        //     if (response.data && response.data.status === 'success') {
        //     console.log("Screenshot has been taken.");
        //     } else if (response.data && response.data.status === 'failed') {
        //     console.log("Screenshot has failed, try in a bit again.");
        //     retryCount++;

        //     if (retryCount < MAX_RETRIES) {
        //         const delay = 0.5 * 60 * 1000; // 3 minutes in milliseconds
        //         console.log(`Retrying after ${delay / 1000} seconds...`);
        //         await new Promise(resolve => setTimeout(resolve, delay));
        //         await captureScreenshot(); // Recursive call to retry
        //     } else {
        //         console.error(`Failed to capture screenshot after ${MAX_RETRIES} retries.`);
        //     }
        //     } else {
        //     console.log("No screenshot is needed.");
        //     }
        // } catch (error) {
        //     console.error('Error:', error);
        // }
        // };

        // captureScreenshot(); // Call the function to start the process


    },
    methods: {
      
      startDrag(event, componentUuid, index) {
        try {
          this.dragging = {
            componentUuid,
            index,
            element: event.target.closest('.relative')
          };
          event.dataTransfer.effectAllowed = 'move';
          event.dataTransfer.setData('text/plain', JSON.stringify({ componentUuid, index }));
          this.dragging.element.style.opacity = '0.5';
          this.draggedZone = "portfolio_item";
        } catch (error) {
          console.error('Error in startDrag:', error);
        }
      },

      endDrag(event) {
        if (this.dragging) {
          this.dragging.element.style.opacity = '1';
          this.dragging = null;
        }
      },

      drag(event) {
        event.preventDefault();
      },

      dragOver(event) {
        event.preventDefault();
        var dropZone = "portfolio_item";
        if (this.draggedZone !== dropZone) {
          event.dataTransfer.dropEffect = 'none';
        } else {
          event.dataTransfer.dropEffect = 'move';
        }
      },

      drop(event, targetComponentUuid, targetIndex) {
        const dropZone = "portfolio_item";
        if (this.draggedZone !== dropZone) {
          event.preventDefault();
          return;
        }
        this.draggedZone = null;

        event.preventDefault();
        try {
          const data = JSON.parse(event.dataTransfer.getData('text/plain'));
          const { componentUuid: sourceComponentUuid, index: sourceIndex } = data;

          if (sourceComponentUuid === targetComponentUuid && sourceIndex !== targetIndex) {
            const component = this.page_component_list.find(c => c.uuid === sourceComponentUuid);
            if (component) {
              const componentData = JSON.parse(component.data);
              const images = componentData.content.images;
              const [movedImage] = images.splice(sourceIndex, 1);
              images.splice(targetIndex, 0, movedImage);
              component.data = JSON.stringify(componentData);
              this.$forceUpdate();
            }
          }
        } catch (error) {
          console.error('Error in drop:', error);
        }
      },


      EditorObjectToHTML(object){
        const htmlContent = new Editor({
        extensions: [
          StarterKit,
          Bold,
          Italic,
          Underline,
          Link.configure({ openOnClick: false }),
          TextAlign.configure({ types: ['heading', 'paragraph'] }),
          Heading.configure({ levels: [1, 2, 3] }),
          Paragraph,
          Image,
          Dropcursor,
          Document,
        ],
        content: object,
      }).getHTML();

      // Create a temporary DOM element to strip the HTML tags
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      let textContent = tempDiv.textContent || tempDiv.innerText || "";

    // Replace new line characters with a space
    textContent = textContent.replace(/\n/g, ' ');

      return textContent;

            
      },
      inputUpdate(uuid, field, event, parent = null){
        const input = event.target.value;

        this.page_components.forEach(item => {
        
          if(item.uuid === uuid) {
            let JSON_uncrypt = JSON.parse(item.data);
            if(parent) {
              JSON_uncrypt[parent][field] = input; 
            } else {
              JSON_uncrypt[field] = input; 
            }
            item.data = JSON.stringify(JSON_uncrypt);
          }

        });
      },
      handleData(data, uuid) {
        this.editors[uuid] = data
      },
      getGeneral(key, value) {
        if(this.general) {
        return this.general.find(item => item[key] === value);
        }
      },
        handleFileUpload(event) {
  
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
                this.uploadFile();
            }
        },
        async uploadFile() {
            this.uploadFailedReason = "";
            if (!this.selectedFile) {
                alert("Please select a file first.");
                return;
            }
            this.uploading = true;
            this.uploadSuccess = false;
            this.uploadError = false;

            const formData = new FormData();
            formData.append('fileToUpload', this.selectedFile);
            formData.append('credilo', this.uploadKey)
            try {
                const response = await fetch(this.uploadLink, {
                method: 'POST',
                body: formData
                });

                if (response.ok) {

                    var text = await response.text();

                    if(text.includes("failed")) {
                        this.uploadFailedReason = text.replace("failed: ", "");
                        this.uploadError = true;
                    } else {
                    this.fileUrl = text;
                    this.uploadSuccess = true;
                    }
                } else {
                this.uploadError = true;
                }
            } catch (error) {
                console.error('Upload failed:', error);
                this.uploadError = true;
            } finally {
                this.uploading = false;
            }
        },


        ChangeType(type) {
          this.getGeneral('key', 'type').value = type;
        },
        ChangeVis(visibility) {
          this.getGeneral('key', 'visibility').value = visibility;
        },
        saveGood() {
            this.saveBTN = 'Saved'
            setTimeout(() => {
                this.saveBTN = 'Save Now'
            }, 3500);
        },
        publicImagePath(src) {
            if (!src) {
                return src;
            }

            src = String(src).replace('files.atw.globalcdn', 'files.atw.global');

            if (/^https?:\/\//i.test(src)) {
                try {
                    src = new URL(src).pathname;
                } catch (e) {
                    // keep original src
                }
            }

            src = src.replace(/^\/?cdn\//, '/');

            if (src.charAt(0) !== '/') {
                src = '/' + src;
            }

            return src;
        },
        cdnUrl(src) {
            if (!src) {
                return '';
            }

            return 'https://' + this.cdn_domain + this.publicImagePath(src);
        },
        normalizeComponentImagePaths(data) {
            if (data.image && data.image.src) {
                data.image.src = this.publicImagePath(data.image.src);
            }

            if (data.content && Array.isArray(data.content.images)) {
                data.content.images.forEach((image) => {
                    if (image && image.src) {
                        image.src = this.publicImagePath(image.src);
                    }
                });
            }

            return data;
        },
        stringifySafely(obj) {
            const seen = new WeakSet();
            return JSON.stringify(obj, (key, value) => {
                if (typeof value === 'object' && value !== null) {
                    if (seen.has(value)) {
                        return; // Remove cyclic reference
                    }
                    seen.add(value);
                }
                return value;
            });
        },

        // gallery start

            // uplaod image

            async uploadImage(event, componentUuid) {
            const file = event.target.files[0];
            if (!file) return;

            //this.uploading = true;
           // this.uploadError = false;
          //  this.uploadSuccess = false;

            const formData = new FormData();
            formData.append('image', file);
            formData.append('uuid', componentUuid);

            try {
                const response = await axios.post('/site/' + this.site_uuid + '/page/' + this.page_uuid + '/upload/single-image', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.status === 200) {
                    const result = response.data;
                    if (result.success) {
                        // Update the component data with the new image
                        const component = this.page_components.find(comp => comp.uuid === componentUuid);

                        if (component) {
                            const data = JSON.parse(component.data);
                            data.image.src = this.publicImagePath(result.path);
                            component.data = JSON.stringify(data);

                        } else {
                      
                        }
                        //this.uploadSuccess = true;
                    } else {
                      
                        this.uploadFailedReason = result.message || 'Upload failed';
                     //   this.uploadError = true;
                        alert("Upload failed, it's probably too big or the wrong file type.");
                    }
                    
               // alert("popup here" + result.path)
                } else {
                  alert("Upload failed, it's probably too big or the wrong file type.");
                    //this.uploadError = true;
                }

            } catch (error) {
                console.error('Upload failed:', error);
               // this.uploadError = true;
               alert("Upload failed, it's probably too big or the wrong file type.");
                this.uploadFailedReason = error.response?.data?.message || 'An error occurred during upload';
            } finally {
   
             //   this.uploading = false;
            }
        },

        async uploadGalleryImage(event, componentUuid) {
            const file = event.target.files[0];
            if (!file) return;

            //this.uploading = true;
           // this.uploadError = false;
          //  this.uploadSuccess = false;

            const formData = new FormData();
            formData.append('image', file);
            formData.append('uuid', componentUuid);

            try {
                const response = await axios.post('/site/' + this.site_uuid + '/page/' + this.page_uuid + '/upload/gallery-image', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.status === 200) {
                    const result = response.data;
                    if (result.success) {
                        // Update the component data with the new image
                        const component = this.page_components.find(comp => comp.uuid === componentUuid);

                        if (component) {
                            const data = JSON.parse(component.data);

                            if(!data.content.images) {
                              data.content.images = [];
                            }

                            data.content.images.push({
                                src: this.publicImagePath(result.path),
                                id:0,
                                title: '',
                                alt: '',
                                description: ''
                            });
                            component.data = JSON.stringify(data);

                        } else {
                          alert("Upload failed: component can not be found for gallery upload.")
                        }
                        //this.uploadSuccess = true;
                    } else {
                      alert("Upload failed, it's probably too big or the wrong file type.");
                        this.uploadFailedReason = result.message || 'Upload failed';
                     //   this.uploadError = true;
                    }
                    
               // alert("popup here" + result.path)
                } else {
                    //this.uploadError = true;
                    alert("Upload failed, it's probably too big or the wrong file type.");
                }

            } catch (error) {
                console.error('Upload failed:', error);
               // this.uploadError = true;\
               alert("Upload failed, it's probably too big or the wrong file type.");
                this.uploadFailedReason = error.response?.data?.message || 'An error occurred during upload';
            } finally {
   
             //   this.uploading = false;
            }
        },

        // gallery end

        save() {
            var saveData = this.editors;

            

            
            // Check if saveData is an object and not null
            if (saveData && typeof saveData === 'object') {
                console.log('Data to save:', saveData);

                var temp_array = [];
                for (const [key, value] of Object.entries(saveData)) {
                  if(value['col_1']) {
                   // temp_array.push({ [key]: value.getJSON() });                    
                  } else {
                    temp_array.push({ [key]: value.getJSON() });
                  }
                }


                
                var temp_array_other = [];

                // remove the content from the data that gets already submitted via content.
                this.page_components.forEach(item => {
                  if(temp_array[item.uuid] !== null) {

                    let JSON_uncrypt = this.normalizeComponentImagePaths(JSON.parse(item.data));
                    // Remove the "content" field
                   // delete JSON_uncrypt.content;

                   // update content
                
                  if (saveData[item.uuid] &&  saveData[item.uuid] !== null) {
                    if(saveData[item.uuid]['col_1']){
                      JSON_uncrypt.col_1 = saveData[item.uuid]['col_1'].getJSON();
                      JSON_uncrypt.col_2 = saveData[item.uuid]['col_2'].getJSON();


                      
                    } else {
                      //JSON_uncrypt.content = saveData[item.uuid].getJSON();

                      console.log(JSON.parse(item.data))
                      if(JSON.parse(item.data).type === 'gallery') {
                        console.log(JSON.parse(item.data).type)
                      } else {
                        JSON_uncrypt.content = saveData[item.uuid].getJSON();
                      }

                    } 
              
                  } 


                    // Optionally, you can reassign this back to `this.item.data` if needed
                    item.data = JSON.stringify(JSON_uncrypt);
                  }

                  temp_array_other.push(item);
                });

                




                // Safely convert the object to a JSON string
                const jsonData = this.stringifySafely(saveData);
//                axios.post('/site/save/'+this.site_uuid+'/page/'+this.page_uuid, {title: this.page.name, general: this.general, content: JSON.stringify(temp_array) })
                axios.post('/site/save/'+this.site_uuid+'/page/'+this.page_uuid, {title: this.page.name, general: this.general, update: temp_array_other })
                    .then(() => {
                        //this.saveBTN = 'Saved successfully';
                        this.saveGood();

                        fetch('/site/capture/' + this.site_uuid + '/page/' + this.page_uuid + '?force=1', {
                          credentials: 'same-origin',
                        }).catch(() => {})

                        if(this.getGeneral('key', 'type').value === "portfolio") {
                          axios.get(`https://${this.domain}${this.page.path.replace("/item/", "/kunst/")}?refresh_cache=true`);
                        } else {
                          axios.get(`https://${this.domain}/buildyour.site/api/cache/remove/?uuid=${this.page_uuid}`);
                        }

                        console.log('Data saved successfully');
                    })
                    .catch(err => {
                        console.error('Error saving data:', err.response || err.message || err);
                        this.saveBTN = 'Failed to save';
                    });
            } else {
                console.log('Invalid data format. Save operation aborted.');
                this.saveBTN = 'Invalid data format';
            }
        },

        // START OF EDTIOR FUNCTIONS

                toggleBold() {
                this.editor.chain().focus().toggleBold().run();
                },
                toggleItalic() {
                this.editor.chain().focus().toggleItalic().run();
                },
                toggleUnderline() {
                this.editor.chain().focus().toggleUnderline().run();
                },
                setLink(editor) {

                    const { state, commands } = editor;

                    // Check if there is a link in the current selection
                    const hasLink = state.doc.nodeAt(state.selection.from)?.marks.some(mark => mark.type.name === 'link');

                    if (hasLink) {
                        // If there's already a link, unset it
                        editor.chain().focus().unsetLink().run();
                    } else {
                        // Otherwise, prompt for a new URL and set the link
                        const url = prompt('Enter link URL:');
                        if (url) {
                            editor.chain().focus().setLink({ href: url }).run();
                        }
                    }

                    // const url = prompt('Enter link URL:');
                    // if (url) {
                    //     this.editor.chain().focus().setLink({ href: url }).run();
                    // }
                },
                setTextAlign(alignment) {
                this.editor.chain().focus().setTextAlign(alignment).run();
                },
                toggleHeading(level) {
                this.editor.chain().focus().toggleHeading({ level }).run();
                },
                setParagraph() {
                this.editor.chain().focus().setParagraph().run();
                },
                addImage() {
                    const url = window.prompt('URL')

                    if (url) {
                        this.editor.chain().focus().setImage({ src: url }).run()
                    }
                },

        // END OF EDTIOR FUNCTIONS

        // START OF POPUP


                // Contact Form Menu
                openFormData(type, parent_uuid, field, index){

                  if(type === 'single-image') {

                      this.field_manager = {type:"single-image", uuid: parent_uuid, index: index, fields: [
                        {
                          "name": "Alt Text",
                          "type": "text",
                          "placeholder": "",
                          "value": field.alt
                        }
                      ]};

                  } else
                  if(type === 'gallery-item') {

                    this.field_manager = {type:"gallery-item", uuid: parent_uuid, index: index, fields: [
                      {
                        "name": "Image Title",
                        "type": "text",
                        "placeholder": "",
                        "value": field.title
                      },
                      {
                        "name": "Alt Text",
                        "type": "text",
                        "placeholder": "",
                        "value": field.alt
                      },
                      {
                        "name": "Image Description",
                        "type": "text",
                        "placeholder": "",
                        "value": field.description
                      } 
                    ]};

                  } else
                  if(type === 'contact_fields') {

                  this.field_manager = {type:"form", uuid: null, index: index, fields: [
                    {
                      "name": null,
                      "type": "",
                      "placeholder": "",
                      "show_name": true
                    },
                    {
                      "name": null,
                      "type": "",
                      "placeholder": "",
                      "show_name": true
                    }
                  ]};

                  // is always first gen, so look in the menu if second gen.
                  this.ContactFormMenu = field;
                  this.field_manager.uuid = parent_uuid;

                  if(field.cols) {
                    this.field_manager.fields[0].name = field.cols[0].name;
                    this.field_manager.fields[0].type = field.cols[0].type;
                    this.field_manager.fields[0].placeholder = field.cols[0].placeholder;
                    this.field_manager.fields[0].show_name = field.cols[0]['show-name'];

                    this.field_manager.fields[1].name = field.cols[1].name;
                    this.field_manager.fields[1].type = field.cols[1].type;
                    this.field_manager.fields[1].placeholder = field.cols[1].placeholder;
                    this.field_manager.fields[1].show_name = field.cols[1]['show-name'];
                  } else {
                    this.field_manager.fields[0].name = field.name;
                    this.field_manager.fields[0].type = field.type;
                    this.field_manager.fields[0].placeholder = field.placeholder;
                    this.field_manager.fields[0].show_name = field['show-name'];
                  }

                  } else if(type === 'faq') {


                    this.field_manager = {"type": "repeater", "repeater_type": "faq", uuid: null, index: index, fields: [
                    {
                      "name": "Question",
                      "text": field.q,
                    },
                    {
                      "name": "Answer",
                      "text": field.a,
                    }
                  ]};  
                  this.ContactFormMenu = field;
                  this.field_manager.uuid = parent_uuid;

                  }  else if(type === 'plans') {



                    const title = new Editor({
                      extensions: [
                        StarterKit,
                        Bold,
                        Italic,
                        Underline,
                        Link.configure({ openOnClick: false }),
                        TextAlign.configure({ types: ['heading', 'paragraph'] }),
                        Heading.configure({ levels: [1, 2, 3] }),
                        Paragraph,
                        Image,
                        Dropcursor,
                        Document,
                      ],
                      content: field.title,
                    });

                    const first_text = new Editor({
                      extensions: [
                        StarterKit,
                        Bold,
                        Italic,
                        Underline,
                        Link.configure({ openOnClick: false }),
                        TextAlign.configure({ types: ['heading', 'paragraph'] }),
                        Heading.configure({ levels: [1, 2, 3] }),
                        Paragraph,
                        Image,
                        Dropcursor,
                        Document,
                      ],
                      content: field.first_text,
                    });

                    const second_text = new Editor({
                      extensions: [
                        StarterKit,
                        Bold,
                        Italic,
                        Underline,
                        Link.configure({ openOnClick: false }),
                        TextAlign.configure({ types: ['heading', 'paragraph'] }),
                        Heading.configure({ levels: [1, 2, 3] }),
                        Paragraph,
                        Image,
                        Dropcursor,
                        Document,
                      ],
                      content: field.second_text,
                    });

                    console.debug([field]);

                    var benefits = [];
                    if(field.benefits) {
                      benefits = field.benefits;
                    }
                    
                    this.field_manager = {"type": "repeater", "repeater_type": "plan", uuid: null, index: index, fields: [
                    {
                      "name": "Title",
                      "text": title,
                    },
                    {
                      "name": "Duration",
                      "text": field.duration,
                    },
                    {
                      "name": "Pricing",
                      "text": field.pricing,
                    },
                    {
                      "name": "First Text",
                      "text": first_text,
                    },
                    {
                      "name": "Benefits",
                      "repeater": benefits,
                    },
                    {
                      "name": "Second Text",
                      "text": second_text,
                    },
                    {
                      "name": "Price Disclaimer",
                      "text": field.price_disclaimer,
                    },
                    {
                      "name": "Price Rightside Text",
                      "text": field.price_rightside_text,
                    },
                    {
                      "name": "Disclaimer",
                      "text": field.disclaimer,
                    },
                    {
                      "name": "Most Chosen",
                      "text": field['most-chosen'],
                    }
                    ]};  
                    this.ContactFormMenu = field;
                    this.field_manager.uuid = parent_uuid;

                  }

                },

                removeImageFormData(parent_uuid, index) {
                  // 1. Filter components by parent_uuid:
                  const pageComponentList = this.page_component_list.filter(
                    (component) => component.uuid === parent_uuid
                  );
                  if(this.field_manager.type === 'single-image'){
                    var data = JSON.parse(pageComponentList[0].data);

                    axios.post('/site/'+this.site_uuid+'/page/'+this.page_uuid+'/remove/single-image', {uuid: parent_uuid})
                    .then(response => {
                      console.log('Image removed successfully');
                      data.image.src = null;
                      data.image.alt = "";
                      pageComponentList[0].data = JSON.stringify(data);
                    })
                    .catch(error => {
                      console.error('Error removing image:', error);
                      alert("Something went wrong when removing the image.")
                    });

                    // Update the component's data
                    pageComponentList[0].data = JSON.stringify(data);
                    this.field_manager.uuid = null;
                   

                  } else
                  if(this.field_manager.type === 'gallery-item'){
                    var data = JSON.parse(pageComponentList[0].data);
                    const galleryIndex = this.field_manager.index;
                    // data.content.images[galleryIndex].title = this.field_manager.fields[0].value;
                    // data.content.images[galleryIndex].alt = this.field_manager.fields[1].value;
                    // data.content.images[galleryIndex].description = this.field_manager.fields[2].value;

                    // first try to remove the image in backend
                    axios.post('/site/'+this.site_uuid+'/page/'+this.page_uuid+'/remove/gallery-item', {uuid: parent_uuid, image: data.content.images[galleryIndex].src})
                    .then(response => {
                      console.log('Image removed successfully');
                      // now remove the image from the array
                      data.content.images.splice(galleryIndex, 1);
                      // Update the component's data
                      pageComponentList[0].data = JSON.stringify(data);
                    })
                    .catch(error => {
                      console.error('Error removing image:', error);
                      alert("Something went wrong when removing the image.")
                    });

                    // Update the component's data
                    pageComponentList[0].data = JSON.stringify(data);

                    this.field_manager.uuid = null;
                  }

                },

                saveFormData(parent_uuid, index) {
                  // 1. Filter components by parent_uuid:
                  const pageComponentList = this.page_component_list.filter(
                    (component) => component.uuid === parent_uuid
                  );


                  // 3. Check if the component is found:
                  if (pageComponentList) {
                    // 4. 
                  if(this.field_manager.type === 'single-image'){
                    var data = JSON.parse(pageComponentList[0].data);
                    data.image.alt = this.field_manager.fields[0].value;
                    pageComponentList[0].data = JSON.stringify(data);
                    this.field_manager.uuid = null;
                  } else  
                  if(this.field_manager.type === 'gallery-item'){
                      var data = JSON.parse(pageComponentList[0].data);
                      const galleryIndex = this.field_manager.index;
                      
                      data.content.images[galleryIndex].title = this.field_manager.fields[0].value;
                      data.content.images[galleryIndex].alt = this.field_manager.fields[1].value;
                      data.content.images[galleryIndex].description = this.field_manager.fields[2].value;

                      // Update the component's data
                      pageComponentList[0].data = JSON.stringify(data);
                      this.field_manager.uuid = null;
                  } else
                  if(this.field_manager.type === 'form'){
                    var data = JSON.parse(pageComponentList[0].data); 
                    // console.log("debug: " + index)
                    // console.log(data.form[index])
                    // return;

                    if(this.field_manager.fields[1].name === null) {
                      // one field
                      data.form[index].name = this.field_manager.fields[0].name;
                      data.form[index].type = this.field_manager.fields[0].type;
                      data.form[index].placeholder = this.field_manager.fields[0].placeholder;
                      data.form[index]['show-name'] = this.field_manager.fields[0].show_name;
                      
                    } else {
                      // two fields
                      data.form[index].cols[0].name = this.field_manager.fields[0].name;
                      data.form[index].cols[0].type = this.field_manager.fields[0].type;
                      data.form[index].cols[0].placeholder = this.field_manager.fields[0].placeholder;
                      data.form[index].cols[0]['show-name'] = this.field_manager.fields[0].show_name;

                      data.form[index].cols[1].name = this.field_manager.fields[1].name;
                      data.form[index].cols[1].type = this.field_manager.fields[1].type;
                      data.form[index].cols[1].placeholder = this.field_manager.fields[1].placeholder;
                      data.form[index].cols[1]['show-name'] = this.field_manager.fields[1].show_name;
                    }

                    // 5. Update the component's data:
                    pageComponentList[0].data = JSON.stringify(data);
                    this.field_manager.uuid = null;
                  } else if(this.field_manager.type === 'repeater'){

                    var data = JSON.parse(pageComponentList[0].data); 

                    // detect type of repeater and use custom logic for that type
                    if(this.field_manager.repeater_type === 'faq') {
                      data.faq.repeater[index].q = this.field_manager.fields[0].text;
                      data.faq.repeater[index].a = this.field_manager.fields[1].text;
                    } else if(this.field_manager.repeater_type === 'plan') {
                      data.plans.repeater[index].title = this.field_manager.fields[0].text.getJSON();
                      data.plans.repeater[index].duration = this.field_manager.fields[1].text;
                      data.plans.repeater[index].pricing = this.field_manager.fields[2].text;
                      data.plans.repeater[index].first_text = this.field_manager.fields[3].text.getJSON();
                      data.plans.repeater[index].benefits = this.field_manager.fields[4].repeater;
                      data.plans.repeater[index].second_text = this.field_manager.fields[5].text.getJSON();
                      data.plans.repeater[index].price_disclaimer = this.field_manager.fields[6].text;
                      data.plans.repeater[index].price_rightside_text = this.field_manager.fields[7].text;
                      data.plans.repeater[index].disclaimer = this.field_manager.fields[8].text;
                      data.plans.repeater[index]['most-chosen'] = this.field_manager.fields[9].text;

                    }

                    pageComponentList[0].data = JSON.stringify(data);
                    this.field_manager.uuid = null;

                  }


                  } else {
                    console.warn('Component with parent_uuid:', parent_uuid, 'and index:', index, 'not found');
                  }
                },

                createFormData(type, parent_uuid, FieldType) {
                  // 1. Filter components by parent_uuid:
                  const pageComponentList = this.page_component_list.filter(
                    (component) => component.uuid === parent_uuid
                  );


                  // 3. Check if the component is found:
                  if (pageComponentList) {
                    // 4. 

                    if(type === 'form'){
                        var data = JSON.parse(pageComponentList[0].data); 
                        var field = "";
                        if(FieldType === 'one-field') {
                          // one field
                          field = {"type":"1-2-cols","cols":[{"type":"text","name":"text","show-name":true,"placeholder":"Just a placeholder"},{"type":"text","name":"text","show-name":false,"placeholder":"Just another placeholder"}]};
                          data.form.splice(data.form.length - 1, 0, field);
                        } else {
                          // two fields
                          field = {"type":"text","name":"text","show-name":true,"placeholder":"Just a placeholder"};
                          data.form.splice(data.form.length - 1, 0, field);
                        }

                        // 5. Update the component's data:
                        pageComponentList[0].data = JSON.stringify(data);
                        this.openFormData('form', parent_uuid, field, (data.form.length - 2));

                      } else if(type === 'faq'){
                        var data = JSON.parse(pageComponentList[0].data); 

                        var field = {"q":"","a":""};
                        data.faq.repeater.push(field);

                        pageComponentList[0].data = JSON.stringify(data);
                        this.openFormData('faq', parent_uuid, field, (data.faq.repeater.length - 1));

                      } else if(type === 'plans'){
                        var data = JSON.parse(pageComponentList[0].data); 

                        var field = {"most-chosen":false,"title":"","duration":0,"pricing":0,"first_text":"","repeater-row":["An benefit"],"second_text":"","price_disclaimer":"excl. 21% btw en reiskosten","price_rightside_text":"Kosten p.p","disclaimer":"Alleen geldig van x tot x"}; 
                        data.plans.repeater.push(field);

                        pageComponentList[0].data = JSON.stringify(data);
                        this.openFormData('plans', parent_uuid, field, (data.plans.repeater.length - 1));

                      }

                  } else {
                    console.warn('Component with parent_uuid:', parent_uuid, 'and index:', index, 'not found');
                  }
                },
                

                removeFormData(type, parent_uuid, index) {
                  // 1. Find the component by parent_uuid:
                  const pageComponent = this.page_component_list.find(
                    (component) => component.uuid === parent_uuid
                  );

                  // 2. Check if the component is found:
                  if (pageComponent) {
                    // 3. Parse the component's data:
                    const data = JSON.parse(pageComponent.data);

                    // 4. Locate the index of the field to remove:
                    const fieldIndex = index;
                    if (fieldIndex !== -1) {
                      if(type === 'contact_fields') {
                        data.form.splice(fieldIndex, 1);
                      } else if(type === 'faq') {
                        data.faq.repeater.splice(fieldIndex, 1);
                      }
                    }

                      // 6. Update the component's data (if needed):
                      pageComponent.data = JSON.stringify(data);

                      // 7. Optional: Clear the field_manager uuid (if this is part of your logic)
                      this.field_manager.uuid = null;

                  } else {
                    console.warn('Component with parent_uuid:', parent_uuid, 'not found');
                  }
                },

                closeFormData() {
                // close ContactFormMenu menu, make sure to ask for saving before.
                this.ContactFormMenu = null;
                },


        // END OF POPUP

        // saveFormData(parent_uuid) {
        // // search parent_uuid and than search field. 
        // },

    },
    beforeUnmount() {
      //this.editor.destroy()
    },
    computed: {

          generalDescription: {
                get() {
                  const item = this.getGeneral('key', 'description');
                  return item ? item.value : '';
                },
                set(newValue) {
                  const item = this.getGeneral('key', 'description');
                  if (item) {
                    item.value = newValue;
                  }
                }
          },
          generalType: {
                get() {
                  const item = this.getGeneral('key', 'type');
                  return item ? item.value : '';
                },
                set(newValue) {
                  const item = this.getGeneral('key', 'type');
                  if (item) {
                    item.value = newValue;
                  }
                }
          },
          generalVisibility: {
                get() {
                  const item = this.getGeneral('key', 'visibility');
                  return item ? item.value : '';
                },
                set(newValue) {
                  const item = this.getGeneral('key', 'visibility');
                  if (item) {
                    item.value = newValue;
                  }
                }
          },
          generalDate: {
                get() {
                  const item = this.getGeneral('key', 'date');
                  return item ? item.value : '';
                },
                set(newValue) {
                  const item = this.getGeneral('key', 'date');
                  if (item) {
                    item.value = newValue;
                  }
                }
          }

    }
  }
</script>
<style lang="scss">


  .on-hover .hover-on {
      display:none !important;
  }

  .hover-on > p {
      cursor: pointer;
  }

  .on-hover:hover input {
      outline: 1px solid #c6c6c6;
  }
  .on-hover:hover .hover-on {
      display:flex !important;
  }
  /* Basic editor styles */
  button i {
    font-family: "Font Awesome 6 Free";
  }
  .tiptap {
    :first-child {
      margin-top: 0;
    }
  
    /* List styles */
    ul,
    ol {
      padding: 0 1rem;
      margin: 1.25rem 1rem 1.25rem 0.4rem;
  
      li p {
        margin-top: 0.25em;
        margin-bottom: 0.25em;
      }
    }
  
    /* Heading styles */
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
      margin-top: 2.5rem;
      text-wrap: pretty;
    }
  
    h1,
    h2 {
      margin-top: 3.5rem;
      margin-bottom: 1.5rem;
    }
  
    h1 {
      font-size: 1.4rem;
    }
  
    h2 {
      font-size: 1.2rem;
    }
  
    h3 {
      font-size: 1.1rem;
    }
  
    h4,
    h5,
    h6 {
      font-size: 1rem;
    }
  
    /* Code and preformatted text styles */
    code {
      background-color: lightsalmon;
      border-radius: 0.4rem;
      color: black;
      font-size: 0.85rem;
      padding: 0.25em 0.3em;
    }
  
    pre {
      background: black;
      border-radius: 0.5rem;
      color: white;
      font-family: 'JetBrainsMono', monospace;
      margin: 1.5rem 0;
      padding: 0.75rem 1rem;
  
      code {
        background: none;
        color: inherit;
        font-size: 0.8rem;
        padding: 0;
      }
    }
  
    blockquote {
      border-left: 3px solid var(--gray-3);
      margin: 1.5rem 0;
      padding-left: 1rem;
    }
  
    hr {
      border: none;
      border-top: 1px solid var(--gray-2);
      margin: 2rem 0;
    }
  }
  
  /* Bubble menu */
  .bubble-menu {
    background-color: white;
    border: 1px solid #d9d9d9;
    border-radius: 0.7rem;
    box-shadow: var(--shadow);
    display: flex;
    gap: 10px;
    padding: 10px;
  
    button {
      background-color: unset;
  
      &:hover {
        background-color: var(--gray-3);
      }
  
      &.is-active {
        background-color: var(--purple);
  
        &:hover {
          background-color: var(--purple-contrast);
        }
      }
    }
  }
  
  /* Floating menu */
  .floating-menu {
    display: flex;
    background-color: var(--gray-3);
    padding: 0.1rem;
    border-radius: 0.5rem;
  
    button {
      background-color: unset;
      padding: 0.275rem 0.425rem;
      border-radius: 0.3rem;
  
      &:hover {
        background-color: var(--gray-3);
      }
  
      &.is-active {
        background-color: var(--white);
        color: var(--purple);
  
        &:hover {
          color: var(--purple-contrast);
        }
      }
    }
  }

  .tippy-box {
    max-width:100% !important;
  }
</style>